// extracted by mini-css-extract-plugin
module.exports = {"container":"buttonV2_container__1aN2Q","contained":"buttonV2_contained__3gQwV","outlined":"buttonV2_outlined__2RhKU","fit":"buttonV2_fit__2NEKe","small":"buttonV2_small__3csIR","medium":"buttonV2_medium__2_mvG","primaryOutlined":"buttonV2_primaryOutlined__39ZKN","primaryContained":"buttonV2_primaryContained__2usx3","secondaryOutlined":"buttonV2_secondaryOutlined__1oZt6","secondaryContained":"buttonV2_secondaryContained__3WGZ_"};
    if(module.hot) {
      // 1790670240462
      var cssReload = require("!../../../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  